import { httpPost } from './apiService';

const roiPdfApiUrl = '/api/pdf';

export async function generatePdf(formData: Record<string, string>, key: string): Promise<Response> {
    const form = JSON.stringify(formData);
    const response = httpPost(`${roiPdfApiUrl}/generate?key=${key}`, form);
    return await response;
}
